import React, { useState } from 'react'
import { useEffect } from 'react'
import { Card, Col, Row, Form, Button, Breadcrumb, InputGroup } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import {toast} from 'react-toastify'
import { API } from '../../App'
import Layout from '../../layout/Layout'
import Cookies from 'js-cookie'
const MutualFundDetailEdit = () => {
  const tokenAuth = async () => {
    const token = Cookies.get('jwt')
    const response = await API.post("/home", {}, { headers: { "Authorization": `Bearer ${token}` } })
    if (response.data.status === false) {
      navigate("/")
    }
  }
  const [validate,setValidate] = useState(false)
  const navigate = useNavigate()
  const { _id } = useParams()
  const [data, setData] = useState([])
  const [user, setUser] = useState({
    Category: "",
    Name: "",
    Image: "",
    Type: "",
    Cap: "",
    Investment: "",
    Return: "",
    MinReturn: "",
    MaxReturn: "",
  })
  const getData = async () => {
    const token = Cookies.get('jwt')
    const fundData = await API.post(`/showFundDetail/${_id}`, {}, { headers: { "Authorization": `Bearer ${token}` } })
    if (fundData.data.status === false) {
      if (fundData.data.response_code === 429) {
        navigate("/")
      } else {
        toast.error('Something went wrong')
      }
    } else {
      setUser({
        Category: fundData.data.data.mutualId,
        Name: fundData.data.data.fundName,
        Image: fundData.data.data.imageLink,
        Type: fundData.data.data.fundType,
        Cap: fundData.data.data.fundCap,
        Investment: fundData.data.data.minInvestment,
        Return: fundData.data.data.threeYReturns,
        MinReturn: fundData.data.data.catMinReturns,
        MaxReturn: fundData.data.data.catMaxReturns,
      })
    }
    const response = await API.post("/getMutualFund", {}, { headers: { "Authorization": `Bearer ${token}` } })
    if (response.data.status === false) {
      if (response.data.response_code === 429) {
        navigate("/")
      } else {
        toast.error('Something went wrong in Mutual Fund List')
      }
    } else {
      setData(response.data.data.data)
    }
  }

  const getVal = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value })
  }

  const [selectedImage, setSelectedImage] = useState(null);

  const onImags = (event) => {
    console.log(event.target.files[0]);
    setSelectedImage(event.target.files[0]);
  }

  const saveData = async () => {
    if (user.Category === "" || user.Name === "" || user.Type === "" || user.Cap === "" || user.Investment === "" ||
      user.Return === "" || user.MinReturn === "" || user.MaxReturn === "") {
        setValidate(true)
    } else {
      if(user.Name.match(/^[A-Za-z& ]+$/) && user.Cap.match(/^[A-Za-z& ]+$/)){
        const Form = new FormData()
        Form.append('category', user.Category)
        Form.append('name', user.Name)
        Form.append('type', user.Type)
        Form.append('cap', user.Cap)
        Form.append('investment', user.Investment)
        Form.append('return', user.Return)
        Form.append('minReturn', user.MinReturn)
        Form.append('maxReturn', user.MaxReturn)
        Form.append('image', selectedImage == null ? user.Image : selectedImage)
        const token = Cookies.get('jwt')
        const response = await API.post(`/editFundDetail/${_id}`, Form, { headers: { "Authorization": `Bearer ${token}` } })
        if (response.data.status === true) {
          toast.success('Fund detail updated Succesfully')
          navigate("/mutualfunddetail")
        } else {
          if (response.data.response_code === 429) {
            navigate("/")
          } else {
            toast.error('Something went wrong')
          }
        }
      }else{
        toast.warning('Enter valid Fund or Cap detail')
      }
    }
  }

  useEffect(() => {
    tokenAuth()
    getData()
  }, [])

  return (
    <Layout sidebar={true}>
      <div className="page-heading">
        <h3>Edit Mutual Fund Detail</h3>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/"><i className='bx bx-home-alt me-2 fs-5' ></i> Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/mutualfunddetail">Mutual Fund Detail List</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Edit Mutual Fund Detail</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <div className="page-content">
      <Form noValidate validated={validate}>
        <Row>
          <Col xs={12}>
            <Card>
              <Card.Body>
                <Row className='align-items-center'>
                  <Col lg={4} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='fund-name'>Fund Category</Form.Label>
                      <Form.Select id="fund-name" className="my-2" name='Category' onChange={(e) => { getVal(e) }}required>
                        <option value="">Select Fund Category</option>
                        {
                          data.map((dataVal, ind) => {
                            return (
                              <option selected={dataVal._id === user.Category ? true : false} value={dataVal._id} key={ind}>{dataVal.name}</option>
                            )
                          })
                        }
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col lg={4} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='fund-cap'>Fund Name</Form.Label>
                      <Form.Control type="text" className="my-2" id='fund-cap' value={user.Name} name='Name' onChange={(e) => { getVal(e) }} placeholder="Enter Your Fund Name" required/>
                    </Form.Group>
                  </Col>

                  <Col lg={4} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='bank-image'>Image</Form.Label>
                      <InputGroup className='my-2'>
                        <Form.Control type="file" id='bank-image' onChange={(e) => { { onImags(e) } }}/>
                        <img src={user.Image} alt="img" height={40} />
                      </InputGroup>
                    </Form.Group>
                  </Col>

                  <Col lg={4} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='bank-name'>Fund Type</Form.Label>
                      <Form.Select id="bank-name" className="my-2" name='Type' onChange={(e) => { getVal(e) }}required>
                        <option value="">Select Fund Type</option>
                        <option selected={"Hybrid" === user.Type ? true : false} value="Hybrid">Hybrid</option>
                        <option selected={"Debt" === user.Type ? true : false} value="Debt">Debt</option>
                        <option selected={"Equity" === user.Type ? true : false} value="Equity">Equity</option>
                        <option selected={"Tax Saver" === user.Type ? true : false} value="Tax Saver">Tax Saver</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col lg={4} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='fund-cap'>Fund Cap</Form.Label>
                      <Form.Control type="text" className="my-2" id='fund-cap' value={user.Cap} name='Cap' onChange={(e) => { getVal(e) }} placeholder="Enter Your Fund Cap" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={4} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='min-investment'>Min Investment</Form.Label>
                      <Form.Control type='text' className="my-2" id='min-investment' value={user.Investment} name='Investment' onChange={(e) => { getVal(e) }} placeholder="Enter Your Min Investment" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={4} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='three-return'>Three Return</Form.Label>
                      <Form.Control type='text' className="my-2" id='three-return' value={user.Return} name='Return' onChange={(e) => { getVal(e) }} placeholder="Enter Your Three Return" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={4} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='cm-returns'>Cat Mini Returns</Form.Label>
                      <Form.Control type='text' className="my-2" id='cm-returns' value={user.MinReturn} name='MinReturn' onChange={(e) => { getVal(e) }} placeholder="Enter Your Cat Mini Returns" required/>
                    </Form.Group>
                  </Col>
                  <Col lg={4} sm={12}>
                    <Form.Group>
                      <Form.Label htmlFor='cm-returns'>Cat Max Returns</Form.Label>
                      <Form.Control type='text' className="my-2" id='cm-returns' value={user.MaxReturn} name='MaxReturn' onChange={(e) => { getVal(e) }} placeholder="Enter Your Cat Max Returns" required/>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
              <Card.Footer className="text-end">
                <Button variant="primary" className="me-3" onClick={saveData}>Save</Button>
                <Link to="/mutualfunddetail">
                  <Button variant="secondary">Cancle</Button>
                </Link>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Form>
      </div>
    </Layout>
  )
}

export default MutualFundDetailEdit